import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { authFetch } from "../Authentication/authService";
import API_Root from "../Constants/API_Root";

const Success = () => {
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  // Prevent duplicate API calls
  const calledRef = useRef(false);

  useEffect(() => {
    if (!location.search || calledRef.current) {
      return;
    }

    calledRef.current = true;
    handlePostCheckout();
  }, [location.search]);

  const handlePostCheckout = async () => {
    try {
      // GET SESSION ID FROM URL
      const queryParams = new URLSearchParams(location.search);
      const sessionId = queryParams.get("session_id");

      console.log("STRIPE SESSION ID:", sessionId);

      if (!sessionId) {
        setError("No Stripe session ID found.");
        setLoading(false);
        return;
      }

      // CALL POST CHECKOUT API
      const response = await authFetch(
        `${API_Root}subscription/post-checkout`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            session_id: sessionId,
          }),
        }
      );

      const data = await response.json();

      console.log("POST CHECKOUT RESPONSE:", data);

      if (response.ok) {
        console.log("Course activated successfully!");

        setSuccess(true);
      } else {
        console.error("Post checkout failed:", data);

        setError(
          data?.message || "Something went wrong while activating the course."
        );
      }
    } catch (error) {
      console.error("POST CHECKOUT ERROR:", error);

      setError("Something went wrong while activating your course.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: "40px",
        textAlign: "center",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {loading && (
        <>
          <h1>Processing Payment...</h1>
          <p>
            Please wait while we confirm your payment and activate your
            course.
          </p>
        </>
      )}

      {!loading && success && (
        <>
          <h1>Payment Successful 🎉</h1>
          <p>Your course has been successfully activated.</p>
        </>
      )}

      {!loading && error && (
        <>
          <h1>Payment Completed</h1>
          <p>{error}</p>
        </>
      )}
    </div>
  );
};

export default Success;